// TipTap wraps every list item's text in a <p>, which Turndown's default rules turn into a "loose"
// list: a blank line between items, whitespace-only lines, and `*   ` / `1.  ` markers. These rules
// write the Markdown a person would type instead (`- item`, `1. item`, no blank lines). Same HTML
// either way, so it only changes how the stored Markdown reads, e.g. in "Edit as Markdown".
export function addTightListRules(service) {
  service.addRule('listItemParagraph', {
    filter: (node) =>
      node.nodeName === 'P' && node.parentNode?.nodeName === 'LI',
    replacement: (content, node) =>
      (node.previousElementSibling ? '\n\n' : '') + content,
  })

  service.addRule('tightListItem', {
    filter: 'li',
    replacement: (content, node) => {
      const parent = node.parentNode
      let prefix = '- '
      if (parent.nodeName === 'OL') {
        const start = parent.getAttribute('start')
        const index = Array.prototype.indexOf.call(parent.children, node)
        prefix = `${start ? Number(start) + index : index + 1}. `
      }
      const indented = content
        .replace(/^\n+/, '')
        .replace(/\n+$/, '\n')
        .replace(/\n/gm, `\n${' '.repeat(prefix.length)}`)
        .replace(/^ +$/gm, '')
      return (
        prefix +
        indented +
        (node.nextSibling && !/\n$/.test(indented) ? '\n' : '')
      )
    },
  })
}
